module.exports = {
  title: "病例管理系统",
  login: {
    user: "账号",
    password: "密码",
    userFreeze: "用户已冻结",
    autoLogin: "两周内自动登录",
    forgetPwd: "忘记密码？",
    loginBtn: "登  录",
    userNameOrPwdEmpty: "用户名或密码不能为空",
    errorDesc: "用户名或密码错误",
    namePlaceholder: "请输入账号",
    pwdPlaceholder: "请输入密码"
  },
  patientMessage: {
    status: {
      "0": "临床情况待完善",
      "4": "STL资料待上传",
      "6": "快递单号待填写",
      "8": "待上传病例",
      "10": "待接收病例",
      "11": "技工主管驳回",
      "12": "待分配病例",
      "15": "模型处理中",
      "18": "方案设计中",
      "20": "DIY方案厂家审核",
      "21": "DIY方案厂家驳回",
      "24": "方案专家审核",
      "25": "专家驳回",
      "27": "方案医生审核",
      "28": "医生驳回",
      "30": "待审核",
      "32": "DIY方案生产审核",
      "33": "DIY方案生产驳回",
      "35": "准备生产",
      "37": "生产中",
      "40": "发货中",
      "42": "第/次发货完成，等待下一次发货",
      "44": "牙套发送完结",
      "46": "已重启",
      "50": "已完成"
    },
    statusFinish: {
      "0": "临床情况已完善",
      "4": "STL资料已上传",
      "6": "快递单号已填写",
      "8": "病例已提交",
      "10": "病例已接收",
      "11": "审核员已驳回",
      "12": "病例已分配",
      "15": "模型处理完成",
      "18": "方案设计完成",
      "20": "DIY方案厂家审核完成",
      "21": "DIY方案厂家已驳回",
      "24": "方案专家完成审核",
      "25": "专家已驳回",
      "27": "方案医生完成审核",
      "28": "医生已驳回",
      "30": "方案提交完成",
      "32": "DIY方案生产审核完成",
      "33": "DIY方案生产已驳回",
      "35": "安排生产",
      "37": "生产完成",
      "40": "发货完成",
      "42": "第/次发货完成，等待下一次发货",
      "44": "牙套发送完结",
      "46": "已重启",
      "50": "已完成"
    },
    patientMes: {
      is_crowded: "拥挤",
      is_interval: "稀疏",
      is_II_I: "II类1分类",
      is_II_II: "II类2分类",
      is_III: "III类",
      is_opening_and_closing: "开合",
      is_anterior_crossbite: "前牙反合",
      is_posterior_teeth: "后牙反合",
      is_deep_draping: "深覆合",
      is_deep_overjet: "深覆盖",
      is_both_edge: "对刃",
      is_expanal_dental_arch: "牙弓狭窄",
      is_gagtooth: "前突",
      is_smile_line_not_neat: "笑线不调",
      is_tooth_abnormlities: "畸形牙",
      is_other: "其它",
      is_periodontal: "牙周红肿",
      is_osteoporosis: "骨质疏松",
      is_inflammation: "口腔炎症",
      is_tmj_problems: "颞颌关节紊乱"
    },
    reason: "理由",
    caseNumber: "病例号",
    orderNumber: "生产批号",
    hasNoData: "此病历还没有上传数据",
    hasSentOut: "已通过快递寄出",
    trackNum: "物流单号",
    newCaseId: "新病例caseId：",
    oldCaseId: "原病例caseId：",
    distributed: "分配技工：",
    caseFile: "病例档案已建立",
    emailInfo: "发送邮箱"
  },
  common: {
    modifyBtn: "修改",
    edit: "编辑",
    save: "保存",
    okBtn: "确定",
    confirm: "确认",
    downLoad: "下载",
    cancelBtn: "取消",
    retreatBtn: "后退",
    backBtn: "返回",
    tempStorageBtn: "暂存",
    prePage: "上一页",
    nextPage: "下一页",
    quitBtn: "退出",
    submitBtn: "提交",
    delBtn: "删除",
    createBtn: "创建",
    delTitle: "确定要删除吗？",
    delContent: "点击确定，将会进行删除，请谨慎操作！",
    reminder: "提示",
    delSuccess: "删除成功",
    CompleteBtn: "完成",
    hasSignOut: "您已退出登录",
    rejectRemarks: "备注",
    mesContent: "该病例已经不能进行该操作",
    notNull: "不能为空",
    Pselect: "请选择",
    Pinput: "请输入",
    required: "必填项目不能为空",
    length800: "请输入(字数800以内)",
    validateText: {
      account: "请输入正确的账号/手机号",
      address: "地址不能含有非法字符",
      password: "请输入6-32位字符",
      // password: '请输入6-20位数字和字母组合',
      rePassword: "两次输入密码不一致",
      phone: "请输入正确的电话号码",
      email: "请输入正确的邮箱",
      name: ["姓名不合法,请输入汉字或字母", "姓名太长，不能超过60个字符"]
    },
    numberInput: "请输入数字",
    total: "共",
    items: "条",
    jumpTo: "跳至",
    page: "页",
    prev: "上一页",
    next: "下一页",
    commitCase: "提交病例",
    backToPatientList: "返回病例列表",
    backToPatientMessage: "返回病例详情页",
    shareToPatient: "病例分享"
  },
  userMessage: {
    title: "个人中心",
    addAddress: "新增邮寄地址",
    modalTitle: "新增邮寄地址",
    modalTitle1: "修改邮寄地址",
    modalNewAddIntro: "建立一个新的地址，用以接收牙齿矫正器械或相关文件",
    userInfoLabel: [
      "用户头像",
      "账 号",
      "密 码",
      "手机号码",
      "电子邮箱",
      "邮寄地址",
      "地址"
    ],
    noData: "暂无数据",
    recipientsText: [
      {
        label: "收件人姓名",
        placeholder: "请输入收件人姓名",
        validateMsg: "收件人姓名不能为空"
      },
      {
        label: "收件人电话",
        placeholder: "手机号、固话、分机等",
        validateMsg1: "收件人电话不能为空",
        validateMsg2: "请填写正确的收件人电话"
      },
      {
        label: "收件人地址",
        placeholder: "请输入收件人地址，详细到门牌号",
        validateMsg: "收件人地址不能为空"
      },
      {
        label: "邮政编号",
        placeholder: "请输入所在地邮编",
        validateMsg1: "邮编不能为空",
        validateMsg2: "请填写正确的邮编"
      },
      {
        label: "诊所名称",
        placeholder: "请输入诊所名称",
        validateMsg: "诊所名称不能为空"
      }
    ],
    noticeMsgErr: "请填写完整正确的信息",
    addMsgSuccess: "新增地址成功",
    updateMsgSuccess: "修改地址成功",
    delMsgSuccess: "删除地址成功",
    editPassword: {
      title: ["修改密码", "请输入您的原登录密码。", "请设置您的新登录密码。"],
      placeholder: ["原密码", "新密码", "再次输入新密码"],
      step: ["输入原始密码", "输入新密码"]
    },
    editPhone: {
      title: ["修改手机号码", "输入您的新手机号，并验证进行修改号码。"],
      placeholder: ["手机号码", "填写验证码"],
      step: ["输入新号码", "验证"]
    },
    editEmail: {
      title: ["修改电子邮箱", "输入新的电子邮箱。"],
      placeholder: "电子邮箱地址"
    },
    responseText: [
      "此手机号码已经被注册",
      "验证码已发送",
      "修改成功",
      "修改失败"
    ],
    selectBtn: ["重选", "确定"],
    hint: "点击或拖动图片至此处，支持JPG、PNG等格式",
    preview: "头像预览"
  },
  //诊断信息页面
  clinicalSetting: {
    title: "临床情况",
    remarks: "医生治疗方案",
    remarks_footer: "注：如医生文字方案与选项冲突，技师默认以文字方案设计",
    clinicalSetting: [
      {
        id: "is_crowded",
        label: "拥挤",
        value: 1
      },
      {
        id: "is_interval",
        label: "稀疏",
        value: 2
      },
      {
        id: "is_deep_draping",
        label: "深覆合",
        value: 3
      },
      {
        id: "is_deep_overjet",
        label: "深覆盖",
        value: 4
      },
      {
        id: "is_II_I",
        label: "II类1分类",
        value: 5
      },
      {
        id: "is_II_II",
        label: "II类2分类",
        value: 6
      },
      {
        id: "is_III",
        label: "III类",
        value: 7
      },
      {
        id: "is_both_edge",
        label: "对刃",
        value: 8
      },
      {
        id: "is_opening_and_closing",
        label: "开合",
        value: 9
      },
      {
        id: "is_anterior_crossbite",
        label: "前牙反合",
        value: 10
      },
      {
        id: "is_posterior_teeth",
        label: "后牙反合",
        value: 11
      },
      {
        id: "is_expanal_dental_arch",
        label: "牙弓狭窄",
        value: 12
      },
      {
        id: "is_periodontal",
        label: "牙周红肿",
        value: 13
      },
      {
        id: "is_inflammation",
        label: "口腔炎症",
        value: 14
      },
      {
        id: "is_osteoporosis",
        label: "骨质疏松",
        value: 15
      },
      {
        id: "is_tmj_problems",
        label: "颞颌关节紊乱",
        value: 16
      },
      {
        id: "is_gagtooth",
        label: "前突",
        value: 17
      },
      {
        id: "is_smile_line_not_neat",
        label: "笑线不调",
        value: 18
      },
      {
        id: "is_tooth_abnormlities",
        label: "畸形牙",
        value: 19
      }
    ]
  },
  /**隐形**/
  transparent: {
    correctionMethodContent: "矫正方式",
    correctionOpts: [
      {
        value: 21,
        label: "磨牙远移"
      },
      {
        value: 22,
        label: "磨牙近移"
      },
      {
        value: 23,
        label: "临面去釉"
      },
      {
        value: 24,
        label: "压低前牙"
      },
      {
        value: 25,
        label: "压低后牙"
      },
      {
        value: 26,
        label: "伸长前牙"
      },
      {
        value: 27,
        label: "升高后牙"
      },
      {
        value: 28,
        label: "前牙唇倾"
      },
      {
        value: 29,
        label: "颌垫"
      },
      {
        value: 30,
        label: "缩弓"
      },
      {
        value: 31,
        label: "后牙舌倾"
      },
      {
        value: 32,
        label: "后牙颊倾"
      },
      {
        value: 33,
        label: "解除扭转"
      },
      {
        value: 34,
        label: "III类牵引"
      },
      {
        value: 35,
        label: "拔智齿"
      }
    ],
    archTreatment: "拟排牙牙弓",
    archTreatmentOpts: [
      {
        value: 1,
        label: "全口"
      },
      {
        value: 2,
        label: "上颌"
      },
      {
        value: 3,
        label: "下颌"
      }
    ],
    exToothTitle: "拔牙/不拔牙",
    extTooth: ["拔牙", "不拔牙"],
    Anchorage: "支抗",
    anchorage: [
      "强：保持后牙失状向位置",
      "中：后牙前移间隙的1/3",
      "弱：后牙前移间隙的1/2"
    ],
    maxilla: "上颌",
    mandible: "下颌",
    midline: "中线",
    adjustment: ["保持", "调整"],
    midlineOpts: [
      {
        name: "左调整",
        label: "2"
      },
      {
        name: "右调整",
        label: "3"
      }
    ],
    overbite: "覆合",
    overlayData: [
      {
        value: "1",
        label: "压低上下前牙",
        children: [
          {
            value: "1",
            label: "正常"
          },
          {
            value: "2",
            label: "I度深覆"
          },
          {
            value: "3",
            label: "II度深覆"
          },
          {
            value: "4",
            label: "III度深覆"
          }
        ]
      },
      {
        value: "2",
        label: "压低上前牙",
        children: [
          {
            value: "1",
            label: "正常"
          },
          {
            value: "2",
            label: "I度深覆"
          },
          {
            value: "3",
            label: "II度深覆"
          },
          {
            value: "4",
            label: "III度深覆"
          }
        ]
      },
      {
        value: "3",
        label: "压低下前牙",
        children: [
          {
            value: "1",
            label: "正常"
          },
          {
            value: "2",
            label: "I度深覆"
          },
          {
            value: "3",
            label: "II度深覆"
          },
          {
            value: "4",
            label: "III度深覆"
          }
        ]
      }
    ],
    cover: "覆盖",
    coverdownList: [
      {
        name: "正常",
        label: "2"
      },
      {
        name: "轻度",
        label: "3"
      },
      {
        name: "中度",
        label: "4"
      },
      {
        name: "重度",
        label: "5"
      }
    ],
    adjustmentDirection: ["左侧", "右侧"],
    molarRelation: "磨牙关系",
    molarRelationList: [
      {
        name: "中性",
        label: "2"
      },
      {
        name: "近中",
        label: "3"
      },
      {
        name: "远中",
        label: "4"
      }
    ],
    crowdings: "牙列拥挤",
    crowdingsChoice: ["保持", "解除拥挤"],
    crowdingsOpts: [
      {
        name: "扩弓",
        label: "1"
      },
      {
        name: "邻面去轴",
        label: "2"
      },
      {
        name: "唇展",
        label: "3"
      },
      {
        name: "磨牙远移",
        label: "4"
      }
    ],
    moveAngle: "牙齿移动步距角度",
    move: "距离",
    angle: "角度",
    moveOptions: [
      /*{
        value: '距离',
        label: '0'
      },*/
      {
        value: "0.15mm",
        label: "1"
      },
      {
        value: "0.2mm",
        label: "2"
      },
      {
        value: "0.25mm",
        label: "3"
      }
    ],
    angleOptions: [
      /*{
        value: '角度',
        label: '0'
      },*/
      {
        value: "1°",
        label: "1"
      },
      {
        value: "2°",
        label: "2"
      },
      {
        value: "3°",
        label: "3"
      }
    ],
    unknown: "未知",
    photoShow: "当 前 病 例 图 片 参 考",
    removable: "不可移动的牙齿",
    adhesive: "不可粘贴附件牙位",
    reserved: "需预留间隙的牙位",
    enamel: "不可邻面去釉牙位",
    corrected: "过矫治",
    correctedNeed: ["需要", "不需要"],
    adhesiveChoice: ["默认附件粘接位置", "不可粘接附件位置"],
    adhesivePrompt: "选默认附件粘接位置则由技师按病例情况粘接附件",
    adhesiveBtn: "确定",
    adhesiveInfoPrompt: "*请参考以下所有附件信息*",
    adhesiveInfoHead: ["附件编号", "附件类型", "功能情况", "附件名称"],
    adhesiveInfo: [
      "前牙长距离移动控根旋转",
      "前牙长距离移动控根旋转比普通D型附件固位效果优化",
      "用于牙齿长距离平移、固位",
      "用于前牙压低、固位",
      "用于前后牙固位，防止矫治器脱位",
      "用于前牙伸长",
      "用于前磨牙伸长"
    ],
    attachmentNameList: [
      "扭转附件",
      "扭转固位附件",
      "垂直矩形",
      "水平矩形",
      "椭圆附件",
      "楔形附件",
      "伸长附件"
    ],
    adhesiveInfoChoice: "* 附件个数不能超过三个"
  },
  dataUpload: {
    fileUpload: "牙齿资料",
    chooseFile: "选取文件",
    downloadBtn: "点击下载文件",
    maxillaryMod: "上颌数字模型",
    mandibleMod: "下颌数字模型",
    clickReUpload: "可点击重新上传",
    fileFormat: "文件格式 .stl",
    correctPlan: "矫治计划上传",
    otherFileUpLoad: "其他文件上传",
    uploadClickCancel: "上传中，点击取消",
    uploadFileText: "上传失败，请重试！",
    fileUploadingText: "文件正在上传中，您确定要离开此页面吗？",
    uploadSuccess: "上传成功",
    fileFormatErr: "文件格式不正确",
    file: "文件",
    formatErrText: " 格式不正确。",
    selectPlan: "请选择临床情况",
    uploadBtn: "点击选择文件上传",
    modalTitle: "提示",
    modalContent: "请上传数字模型或输入有效的快递单号",
    maxSizeWarning: "文件不能超过200M",
    reminderContent: "重新上传可覆盖当前文件",
    express: "快递单号",
    expressCompany: "快递公司",
    expressDes:
      "如您没有上传.stl 文件，可通过快递将牙模快递给我们，在收到您寄出的牙模后，我们会尽快为您处理病例",
    expressList: [
      {
        id: 1,
        value: "顺丰",
        label: "顺丰"
      },
      {
        id: 7,
        value: "德邦",
        label: "德邦"
      },
      {
        id: 2,
        value: "EMS",
        label: "EMS"
      },
      {
        id: 3,
        value: "圆通",
        label: "圆通"
      },
      {
        id: 4,
        value: "申通",
        label: "申通"
      },
      {
        id: 5,
        value: "中通",
        label: "中通"
      },
      {
        id: 6,
        value: "韵达",
        label: "韵达"
      }
    ],
    expressTip: "请输入正确格式的单号",
    submitTip: "保存好病例后如需提交 请在病例列表中点击提交病例按钮"
  },
  photoUpload: {
    facePhoto: "面部照片",
    // fullFace: '正面照',
    fullFace: "正面相（默认患者头像）",
    fullFace1: "",
    fullFaceSmile: "正面微笑照",
    side45: "侧面45°照",
    side90: "侧面90°照",
    intraoral: "口内照片",
    maxillary: "上颌",
    maxLeft: "左侧",
    maxRight: "右侧",
    maxOpening: "开口",
    mandible: "下颌",
    lateralXray: "侧面X光",
    positiveXray: "正面X光",
    uploadFileText: "上传失败，请重试！",
    uploadSuccess: "上传成功",
    rotateSuccess: "旋转成功",
    XRay: "X光照片",
    sideXPhoto: "头颅侧位定位片",
    panoramicXPhoto: "全颌曲面断层片",
    full: "正位",
    upper: "上颌颌面照",
    down: "下颌颌面照",
    left: "左侧位",
    right: "右侧位",
    turnForward: "点击可顺时针旋转图片",
    turnReverse: "点击可逆时针旋转图片",
    errorMsg: ["图片上传错误", "图片服务器错误"],
    file: "照片",
    formatErrText: "格式不正确，请上传jpg,png,bmp格式的照片。",
    lateralPosition: "右侧面相",
    frontalBite: "正面咬合照",
    rightBite: "右侧咬合照",
    leftBite: "左侧咬合照",
    photoNoUpload: "病历还没有上传此照片"
  },
  patientList: {
    state: [
      { key: "0", stateContent: "临床情况待完善" },
      { key: "4", stateContent: "STL资料待上传" },
      { key: "6", stateContent: "快递单号已填写" },
      { key: "8", stateContent: "待上传病例" },
      { key: "10", stateContent: "待接收病例" },
      { key: "11", stateContent: "技工主管驳回" },
      { key: "12", stateContent: "待分配病例" },
      { key: "15", stateContent: "模型处理中" },
      { key: "18", stateContent: "方案设计中" },
      { key: "20", stateContent: "DIY方案厂家审核" },
      { key: "21", stateContent: "DIY方案厂家驳回" },
      { key: "24", stateContent: "方案专家审核" },
      { key: "25", stateContent: "专家驳回" },
      { key: "27", stateContent: "方案医生审核" },
      { key: "28", stateContent: "医生驳回" },
      { key: "30", stateContent: "待审核" },
      { key: "32", stateContent: "DIY方案生产审核" },
      { key: "33", stateContent: "DIY方案生产驳回" },
      { key: "35", stateContent: "准备生产" },
      { key: "37", stateContent: "生产中" },
      { key: "40", stateContent: "发货中" },
      { key: "42", stateContent: "第/次发货完成，等待下一次发货" },
      { key: "44", stateContent: "牙套发送完结" },
      { key: "46", stateContent: "已重启" },
      { key: "50", stateContent: "已完成" }
    ],
    // 默认
    stateCaseListOnShow: [
      { key: "0", stateContent: "临床情况待完善" },
      { key: "4", stateContent: "STL资料待上传" },
      { key: "6", stateContent: "快递单号已填写" },
      { key: "8", stateContent: "待上传病例" },
      { key: "10", stateContent: "待接收病例" },
      { key: "11", stateContent: "技工主管驳回" },
      { key: "12", stateContent: "待分配病例" },
      { key: "15", stateContent: "模型处理中" },
      { key: "18", stateContent: "方案设计中" },
      { key: "20", stateContent: "DIY方案厂家审核" },
      { key: "21", stateContent: "DIY方案厂家驳回" },
      { key: "24", stateContent: "方案专家审核" },
      { key: "25", stateContent: "专家驳回" },
      { key: "27", stateContent: "方案医生审核" },
      { key: "28", stateContent: "医生驳回" },
      { key: "30", stateContent: "待审核" },
      { key: "32", stateContent: "DIY方案生产审核" },
      { key: "33", stateContent: "DIY方案生产驳回" },
      { key: "35", stateContent: "准备生产" },
      { key: "37", stateContent: "生产中" },
      { key: "40", stateContent: "发货中" },
      { key: "42", stateContent: "等待下一次发货" },
      { key: "44", stateContent: "牙套发送完结" },
      { key: "46", stateContent: "已重启" },
      { key: "50", stateContent: "已完成" }
    ],
    // 医生
    stateCaseListOnShow_doctor: [
      { key: "0", stateContent: "临床情况待完善" },
      { key: "4", stateContent: "STL资料待上传" },
      { key: "6", stateContent: "快递单号已填写" },
      { key: "8", stateContent: "待上传病例" },
      { key: "10", stateContent: "待接收病例" },
      { key: "11", stateContent: "技工主管驳回" },
      { key: "12", stateContent: "待分配病例" },
      { key: "15", stateContent: "模型处理中" },
      { key: "18", stateContent: "方案设计中" },
      { key: "20", stateContent: "DIY方案厂家审核" },
      { key: "21", stateContent: "DIY方案厂家驳回" },
      { key: "24", stateContent: "方案专家审核" },
      { key: "25", stateContent: "专家驳回" },
      { key: "27", stateContent: "方案医生审核" },
      { key: "28", stateContent: "医生驳回" },
      { key: "30", stateContent: "待审核" },
      { key: "32", stateContent: "DIY方案生产审核" },
      { key: "33", stateContent: "DIY方案生产驳回" },
      { key: "35", stateContent: "准备生产" },
      { key: "37", stateContent: "生产中" },
      { key: "40", stateContent: "发货中" },
      { key: "42", stateContent: "等待下一次发货" },
      { key: "44", stateContent: "牙套发送完结" },
      { key: "46", stateContent: "已重启" },
      { key: "50", stateContent: "已完成" }
    ],
    // 审核员
    stateCaseListOnShow_verify: [
      { key: "0", stateContent: "临床情况待完善" },
      { key: "4", stateContent: "STL资料待上传" },
      { key: "6", stateContent: "快递单号已填写" },
      { key: "8", stateContent: "待上传病例" },
      { key: "10", stateContent: "待接收病例" },
      { key: "11", stateContent: "技工主管驳回" },
      { key: "12", stateContent: "待分配病例" },
      { key: "15", stateContent: "模型处理中" },
      { key: "18", stateContent: "方案设计中" },
      { key: "20", stateContent: "DIY方案厂家审核" },
      { key: "21", stateContent: "DIY方案厂家驳回" },
      { key: "24", stateContent: "方案专家审核" },
      { key: "25", stateContent: "专家驳回" },
      { key: "27", stateContent: "方案医生审核" },
      { key: "28", stateContent: "医生驳回" },
      { key: "30", stateContent: "待审核" },
      { key: "32", stateContent: "DIY方案生产审核" },
      { key: "33", stateContent: "DIY方案生产驳回" },
      { key: "35", stateContent: "准备生产" },
      { key: "37", stateContent: "生产中" },
      { key: "40", stateContent: "发货中" },
      { key: "42", stateContent: "等待下一次发货" },
      { key: "44", stateContent: "牙套发送完结" },
      { key: "46", stateContent: "已重启" },
      { key: "50", stateContent: "已完成" }
    ],
    // 数据审核员
    stateCaseListOnShow_dataverify: [
      { key: "0", stateContent: "临床情况待完善" },
      { key: "4", stateContent: "STL资料待上传" },
      { key: "6", stateContent: "快递单号已填写" },
      { key: "8", stateContent: "待上传病例" },
      { key: "10", stateContent: "待接收病例" },
      { key: "11", stateContent: "技工主管驳回" },
      { key: "12", stateContent: "待分配病例" },
      { key: "15", stateContent: "模型处理中" },
      { key: "18", stateContent: "方案设计中" },
      { key: "20", stateContent: "DIY方案厂家审核" },
      { key: "21", stateContent: "DIY方案厂家驳回" },
      { key: "24", stateContent: "方案专家审核" },
      { key: "25", stateContent: "专家驳回" },
      { key: "27", stateContent: "方案医生审核" },
      { key: "28", stateContent: "医生驳回" },
      { key: "30", stateContent: "待审核" },
      { key: "32", stateContent: "DIY方案生产审核" },
      { key: "33", stateContent: "DIY方案生产驳回" },
      { key: "35", stateContent: "准备生产" },
      { key: "37", stateContent: "生产中" },
      { key: "40", stateContent: "发货中" },
      { key: "42", stateContent: "等待下一次发货" },
      { key: "44", stateContent: "牙套发送完结" },
      { key: "46", stateContent: "已重启" },
      { key: "50", stateContent: "已完成" }
    ],
    // 专家
    stateCaseListOnShow_expert: [
      { key: "0", stateContent: "临床情况待完善" },
      { key: "4", stateContent: "STL资料待上传" },
      { key: "6", stateContent: "快递单号已填写" },
      { key: "8", stateContent: "待上传病例" },
      { key: "10", stateContent: "待接收病例" },
      { key: "11", stateContent: "技工主管驳回" },
      { key: "12", stateContent: "待分配病例" },
      { key: "15", stateContent: "模型处理中" },
      { key: "18", stateContent: "方案设计中" },
      { key: "20", stateContent: "DIY方案厂家审核" },
      { key: "21", stateContent: "DIY方案厂家驳回" },
      { key: "24", stateContent: "方案专家审核" },
      { key: "25", stateContent: "专家驳回" },
      { key: "27", stateContent: "方案医生审核" },
      { key: "28", stateContent: "医生驳回" },
      { key: "30", stateContent: "待审核" },
      { key: "32", stateContent: "DIY方案生产审核" },
      { key: "33", stateContent: "DIY方案生产驳回" },
      { key: "35", stateContent: "准备生产" },
      { key: "37", stateContent: "生产中" },
      { key: "40", stateContent: "发货中" },
      { key: "42", stateContent: "等待下一次发货" },
      { key: "44", stateContent: "牙套发送完结" },
      { key: "46", stateContent: "已重启" },
      { key: "50", stateContent: "已完成" }
    ],

    casePlan: ["隐形矫治", "舌侧矫治", "未选择治疗计划"],
    kmFilterStateDoctor: [
      {
        label: "全部病例",
        value: 0,
        filter: []
      },
      {
        label: "待上传",
        value: 1,
        filter: [0, 4, 6, 8, 11]
      },
      {
        label: "待接收",
        value: 2,
        filter: [10, 12]
      },
      {
        label: "方案设计中",
        value: 3,
        filter: [15, 18, 24, 25, 28]
      },
      {
        label: "待审核",
        value: 4,
        filter: [27, 30]
      },
      {
        label: "生产中",
        value: 6,
        filter: [20, 21, 32, 33, 35, 37]
      },
      {
        label: "治疗中",
        value: 7,
        filter: [40, 42, 44, 46]
      },
      {
        label: "已完成",
        value: 8,
        filter: [50]
      }
    ],
    kmFilterStateDesignCenter: [
      {
        label: "全部病例",
        value: 0,
        filter: []
      },
      {
        label: "待设计",
        value: 1,
        filter: [0, 4, 6, 8, 11, 10, 12]
      },
      /*{
        label: '待接收',
        value: 2,
        filter: [],
      },*/
      {
        label: "方案设计中",
        value: 3,
        filter: [15, 18, 21, 25, 28, 33]
      },
      {
        label: "待审核",
        value: 4,
        filter: [24, 27]
      },
      {
        label: "生产中",
        value: 6,
        filter: [20, 30, 32, 35, 37]
      },
      {
        label: "治疗中",
        value: 7,
        filter: [40, 42, 44, 46]
      },
      {
        label: "已完成",
        value: 8,
        filter: [50]
      }
    ],
    kmFilterStateDesignCenterDoctor: [
      {
        label: "全部病例",
        value: 0,
        filter: []
      },
      {
        label: "待设计",
        value: 1,
        filter: [0, 4, 6, 8, 11, 10, 12]
      },
      /*{
        label: '待接收',
        value: 2,
        filter: [],
      },*/
      {
        label: "方案设计中",
        value: 3,
        filter: [15, 18, 21, 24, 25, 28, 33]
      },
      {
        label: "待审核",
        value: 4,
        filter: [27]
      },
      {
        label: "生产中",
        value: 6,
        filter: [20, 30, 32, 35, 37]
      },
      {
        label: "治疗中",
        value: 7,
        filter: [40, 42, 44, 46]
      },
      {
        label: "已完成",
        value: 8,
        filter: [50]
      }
    ],
    kmFilterStateDesignCenterExpert: [
      {
        label: "全部病例",
        value: 0,
        filter: []
      },
      {
        label: "待设计",
        value: 1,
        filter: [0, 4, 6, 8, 11, 10, 12]
      },
      /*{
        label: '待接收',
        value: 2,
        filter: [],
      },*/
      {
        label: "方案设计中",
        value: 3,
        filter: [15, 18, 21, 25, 28, 33]
      },
      {
        label: "专家审核",
        value: 5,
        filter: [24]
      },
      {
        label: "待审核",
        value: 4,
        filter: [27]
      },
      {
        label: "生产中",
        value: 6,
        filter: [20, 30, 32, 35, 37]
      },
      {
        label: "治疗中",
        value: 7,
        filter: [40, 42, 44, 46]
      },
      {
        label: "已完成",
        value: 8,
        filter: [50]
      }
    ],
    kmFilterStateDesignCenterProduce: [
      {
        label: "全部病例",
        value: 0,
        filter: []
      },
      {
        label: "待设计",
        value: 1,
        filter: [0, 4, 6, 8, 11, 10, 12]
      },
      /*{
        label: '待接收',
        value: 2,
        filter: [],
      },*/
      {
        label: "方案设计中",
        value: 3,
        filter: [15, 18, 21, 25, 28, 33]
      },
      {
        label: "待审核",
        value: 4,
        filter: [24, 27]
      },
      {
        label: "确认生产",
        value: 9,
        filter: [35]
      },
      {
        label: "生产中",
        value: 6,
        filter: [20, 30, 32, 37]
      },
      {
        label: "治疗中",
        value: 7,
        filter: [40, 42, 44, 46]
      },
      {
        label: "已完成",
        value: 8,
        filter: [50]
      }
    ],
    kmFilterStateDesignCenterDeliver: [
      {
        label: "全部病例",
        value: 0,
        filter: []
      },
      {
        label: "待设计",
        value: 1,
        filter: [0, 4, 6, 8, 11, 10, 12]
      },
      /*{
        label: '待接收',
        value: 2,
        filter: [],
      },*/
      {
        label: "方案设计中",
        value: 3,
        filter: [15, 18, 21, 25, 28, 33]
      },
      {
        label: "待审核",
        value: 4,
        filter: [24, 27]
      },
      {
        label: "确认发货",
        value: 9,
        filter: [37]
      },
      {
        label: "生产中",
        value: 6,
        filter: [20, 30, 32, 35]
      },
      {
        label: "治疗中",
        value: 7,
        filter: [40, 42, 44, 46]
      },
      {
        label: "已完成",
        value: 8,
        filter: [50]
      }
    ],
    kmFilterStateDesignCenterSupervisor: [
      {
        label: "全部病例",
        value: 0,
        filter: []
      },
      {
        label: "待设计",
        value: 1,
        filter: [0, 4, 6, 8, 11]
      },
      {
        label: "待接收",
        value: 10,
        filter: [10, 12]
      },
      /*{
        label: '待接收',
        value: 2,
        filter: [],
      },*/
      {
        label: "方案设计中",
        value: 3,
        filter: [15, 18, 21, 25, 28, 33]
      },
      {
        label: "待审核",
        value: 4,
        filter: [24, 27]
      },
      {
        label: "生产中",
        value: 6,
        filter: [20, 30, 32, 35, 37]
      },
      {
        label: "治疗中",
        value: 7,
        filter: [40, 42, 44, 46]
      },
      {
        label: "已完成",
        value: 8,
        filter: [50]
      }
    ],
    kmFilterStateDesignCenterVerify: [
      {
        label: "全部病例",
        value: 0,
        filter: []
      },
      {
        label: "待设计",
        value: 1,
        filter: [0, 4, 6, 8, 11, 10, 12]
      },
      /*{
        label: '待接收',
        value: 2,
        filter: [],
      },*/
      {
        label: "方案设计中",
        value: 3,
        filter: [15, 18, 21, 25, 28, 33]
      },
      {
        label: "待审核",
        value: 4,
        filter: [24, 27, 30, 20, 32]
      },
      // {
      //   label: "确认方案",
      //   value: 9,
      //   filter: []
      // },
      {
        label: "生产中",
        value: 6,
        filter: [35, 37]
      },
      {
        label: "治疗中",
        value: 7,
        filter: [40, 42, 44, 46]
      },
      {
        label: "已完成",
        value: 8,
        filter: [50]
      }
    ],
    kmCaseListStateDoctor: [
      "待上传",
      "待接收",
      "方案设计中",
      "待审核中",
      "治疗中",
      "生产中",
      "已完成"
    ],
    kmCaseListStateDesignCenter: [
      "待设计",
      "方案设计中",
      "待审核",
      "生产中",
      "治疗中"
    ],
    caseClassification: [
      {
        key: "1",
        stateContent: "青少年(8-18岁)"
      },
      {
        key: "2",
        stateContent: "成人(18-35岁)"
      },
      {
        key: "3",
        stateContent: "中老年(35岁以上)"
      },
      {
        key: "4",
        stateContent: "安氏Ｉ类"
      },
      {
        key: "5",
        stateContent: "安氏Ⅱ类"
      },
      {
        key: "6",
        stateContent: "安氏Ⅲ类"
      },
      {
        key: "7",
        stateContent: "拔牙"
      },
      {
        key: "8",
        stateContent: "拔下切牙"
      },
      {
        key: "9",
        stateContent: "磨牙远移"
      },
      {
        key: "10",
        stateContent: "磨牙近移"
      },
      {
        key: "11",
        stateContent: "开颌"
      },
      {
        key: "12",
        stateContent: "深覆合深覆盖"
      },
      {
        key: "13",
        stateContent: "后牙正跨颌"
      },
      {
        key: "14",
        stateContent: "牙弓偏斜"
      },
      {
        key: "15",
        stateContent: "牙周病"
      }
    ],
    action1: {
      "0": "补充资料",
      "4": "补充资料",
      "6": "补充资料",
      "8": "病例提交",
      "10": "接收",
      "11": "",
      "12": "分配",
      "18": "",
      "20": "审核",
      "21": "",
      "24": "审核",
      "25": "",
      "27": "审核",
      "28": "",
      "30": "生产",
      "32": "审核",
      "33": "",
      "35": "确认生产",
      "37": "发货",
      "40": "收货",
      "42": "生产",
      "44": "完结",
      "46": "",
      "50": ""
    },
    action1Doctor: {
      "0": "补充资料",
      "4": "补充资料",
      "6": "补充资料",
      "8": "病例提交",
      "10": "",
      "11": "",
      "12": "",
      "18": "",
      "20": "",
      "21": "",
      "24": "",
      "25": "",
      "27": "审核",
      "28": "",
      "30": "生产",
      "32": "",
      "33": "",
      "35": "",
      "37": "",
      "40": "收货",
      "42": "生产",
      "44": "完结",
      "46": "",
      "50": ""
    },
    action1Produce: {
      "0": "",
      "4": "",
      "6": "",
      "8": "",
      "10": "",
      "11": "",
      "12": "",
      "18": "",
      "20": "",
      "21": "",
      "24": "",
      "25": "",
      "27": "",
      "28": "",
      "30": "",
      "32": "审核",
      "33": "",
      "35": "确认生产",
      "37": "发货",
      "40": "",
      "42": "",
      "44": "",
      "46": "",
      "50": ""
    },
    action1Judge: {
      "4": "addInfoCaseBtn",
      "8": "submitCaseBtn",
      "10": "acceptCaseBtn",
      "12": "allocateCaseBtn",
      "20": "diyTpAuditBtn",
      "24": "expertAuditBtn",
      "27": "doctorAuditBtn",
      "30": "startProductBtn",
      "32": "diyTpAuditBtn",
      "35": "confirmProductBtn",
      "37": "orderShipmentBtn",
      "40": "confirmReceiptBtn",
      "42": "startProductBtn",
      "44": "completeBtn"
    },
    action2: {
      "10": "驳回",
      "12": "领取",
      "20": "驳回",
      "24": "",
      "27": "",
      "32": "驳回",
      "42": "阶段调整",
      "44": "阶段调整"
    },
    action2Doctor: {
      "10": "",
      "12": "",
      "20": "",
      "24": "",
      "27": "",
      "32": "",
      "42": "阶段调整",
      "44": "阶段调整"
    },
    action2Produce: {
      "10": "",
      "12": "",
      "20": "",
      "24": "",
      "27": "",
      "30": "驳回",
      "32": "驳回",
      "42": "",
      "44": ""
    },
    action2Judge: {
      "10": "deniedCaseBtn",
      "12": "getCaseBtn",
      "20": "diyTpDeniedBtn",
      "32": "diyTpDeniedBtn",
      "42": "stageAdjustmentBtn",
      "44": "stageAdjustmentBtn"
    },
    actionTips: {
      "21": "领取当前病例交由该自己进行处理",
      "8": "确认提交该病例",
      "10": "确认接收该病例",
      "20": "确认通过该方案",
      "30": "确认生产该病例",
      "32": "确认通过该方案",
      "35": "确认生产该病例",
      "40": "确认收货",
      "44": "确认完结该病例"
    },
    actionTips1: {
      "20": "确认驳回该方案",
      "30": "确认驳回该方案",
      "32": "确认驳回该方案"
    },
    actionTitle: {
      "12": "领取病例",
      "8": "提交病例",
      "30": "安排生产",
      "35": "确认生产",
      "37": "安排发货",
      "40": "收货",
      "42": "安排生产"
    },
    archTypeContent: ["上颌", "下颌"],
    expressNum: "请输入寄出的快递单号",
    batchSending: "分批发送",
    courierNumber: "快递单号 ",
    expressBatchTip: "值在1-100之间",
    firstLogTip: "知道了",
    manAndMaxSteps: ["上颌步骤", "下颌步骤"],
    placeholderSteps: "步骤",
    manAndMaxNum: ["上颌数量", "下颌数量"],
    placeholderNum: "数量",
    emailTitle: "发送邮箱"
  },
  easyCause: {
    title: "透明矫治器设计单",
    easyCode: "微信扫码，即可在手机上查看",
    middle: {
      orthodonticSelect: "拟矫治牙弓",
      orthodonticNum: ["全口", "上颌", "下颌"],
      extraction: "拔牙情况",
      anchorage: "支抗",
      centerLine: "中线",
      overbite: "覆合",
      cover: "覆盖",
      molar: "磨牙关系",
      crowding: "牙列拥挤",
      moveAngle: "牙齿移动步距角度",
      notShow: "未填写"
    },
    right: {
      removable: "不可移动牙齿",
      adhesive: "不可粘接附件位置",
      reserved: "需预留间隙牙位",
      enamel: "不可邻面去釉牙位",
      corrected: "过矫治"
    },
    markers: "牙位标记",
    modalTitle: "病例单",
    modalContent: "请确认病例单信息是否无误",
    gender: ["男", "女"],
    htmlTile: "透明矫治器设计单",
    fujian: [
      {
        label: "1",
        value: "默认附件粘接位置"
      },
      {
        label: "2",
        value: "附件粘接位置"
      }
    ],
    need: [
      {
        label: "1",
        value: "需要"
      },
      {
        label: "2",
        value: "不需要"
      }
    ]
  },
  threeDisplayContent: {
    approveButtonContent: "立即审核",
    approveWindowTitle: "立即审核",
    approvedResult: "审核结果",
    approveOperateBtn: ["取消", "确认"],
    seeAllItem: "查看全部",
    radioButtonItemLabOfTooth: [
      {
        label: "冠",
        value: "crownInfo"
      }
      // {
      //   label: "阻抗中心",
      //   value: "impedance"
      // },
      // {
      //   label: "根尖",
      //   value: "rootTip"
      // }
    ],
    toothMove: [
      "近中",
      "远中",
      "唇向",
      "舌向",
      "升高",
      "压低",
      "平移",
      "扭转",
      "轴倾",
      "转矩",
      "颊向"
    ],
    toothMoveOfArchTitleTabs: [
      {
        label: "上颌移动表",
        value: 0
      },
      {
        label: "下颌移动表",
        value: 1
      }
    ],
    stepPlanIntroOfArchTitleTabs: [
      {
        label: "上颌",
        value: 0
      },
      {
        label: "下颌",
        value: 1
      }
    ],
    approveStatusLab: ["已审批", "演示", "未通过", "未审核"],
    historicalTpTitle: "历史方案",
    exportTitle: "导出",
    exportOperateBtn: ["取消", "导出"],
    shareConfigTitle: "分享",
    shareOperateBtn: ["取消", "创建分享链接"],
    shareSuccessDialogBtn: ["关闭", "复制"],
    imageDocTitle: "患者照片",
    patientsDemand: "患者主诉",
    planContent: "诊断信息",
    treatmentPlan: "治疗方案",
    uploadCTDile: "上传CT文件（只能上传zip，rar，7z格式）",

    designDetailTitle: "设计详单",
    boltonPageTitle: "Bolton分析（mm）",
    boltonPageContent: ["冠宽 (mm)"],
    stepIntroPageTitle: "分步信息",
    correctionInstructionPageTitle: "矫治说明",
    orderNumber: "订单编号:",
    patientName: "患者姓名",
    designDate: "设计日期",
    treatmentSteps: "治疗步骤",
    stepsLab: ["上颌", "下颌"],
    operateNotice: "临床操作提示",
    stepNumLab: ["第", "步"],
    tpDetailLab: "从该步矫治器开始，在以下牙齿上粘贴附件：",
    iprDetailLab: ["在该补矫治器之前，在以下牙位进行邻面去釉：", "间："],
    attachmentPicLab: "粘贴附件分布图",
    iprPicLab: "邻面去釉分步图",
    stepMaskLab: "步",
    iprStepMaskLab: "步前",
    stepIntroMarksList: [
      {
        label: "附件粘贴",
        value: "pasteAttach",
        icon: "ico_paste_attach_tab_marks",
        tooltipEnable: true,
        marksPanelDisplay: true
      },
      {
        label: "附件磨除",
        value: "removeAttach",
        icon: "ico_remove_attach_tab_marks",
        tooltipEnable: true,
        marksPanelDisplay: true
      },
      {
        label: "附件更换",
        value: "replaceAttach",
        icon: "ico_replace_attach_tab_marks",
        tooltipEnable: true,
        marksPanelDisplay: true
      },
      {
        label: "不可移动",
        value: "notMove",
        icon: "ico_not_move_tab_marks",
        tooltipEnable: false,
        marksPanelDisplay: true
      },
      {
        label: "临面去釉",
        value: "ipr",
        icon: "ico_ipr_tab_marks",
        tooltipEnable: true,
        marksPanelDisplay: true
      },
      {
        label: "咬合跳跃",
        value: "biteJump",
        icon: "ico_bite_jump_tab_marks",
        tooltipEnable: false,
        marksPanelDisplay: true
      },
      {
        label: "缺牙/拔牙",
        value: "toothExist",
        icon: "ico_tooth_exist_tab_marks",
        tooltipEnable: false,
        marksPanelDisplay: true
      },
      {
        label: "牙齿移动",
        value: "toothMove",
        icon: "ico_tooth_move_tab_marks",
        tooltipEnable: false,
        marksPanelDisplay: true
      },
      {
        label: "节点",
        value: "stage",
        icon: "ico_flag_tab_marks",
        tooltipEnable: false,
        marksPanelDisplay: false
      }
    ],
    toothMovePos: ["平移", "旋转", "轴倾", "转矩"],
    toothDataOptions: [
      "升高(E)/压低(I) (mm)",
      "颊向(B)/舌向(L) (mm)",
      "近中(M)/远中(D) (mm)",
      "近中(M)/远中(D)",
      "近中(M)/远中(D)",
      "颊向(B)/舌向(L)"
    ],
    tpNoticeLab: "模拟方案，实际治疗效果可能不同"
  },
  caseDetail: {
    navigateList: [
      {
        label: "患者主页",
        value: "detailHome",
        icon: "",
        enable: false
      },
      {
        label: "影像资料",
        value: "imageDocument",
        icon: "ico_image_document",
        enable: true
      },
      {
        label: "数字模型",
        value: "digitalModule",
        icon: "ico_digital_module",
        enable: true
      },
      {
        label: "方案管理",
        value: "tpManager",
        icon: "ico_tp_manager",
        enable: true
      },
      {
        label: "设计详单",
        value: "designDetail",
        icon: "ico_design_detail",
        enable: true
      },
      {
        label: "3D设计说明",
        value: "tpIntro",
        icon: "ico_tp_intro",
        enable: true
      },
      {
        label: "矫治器订单",
        value: "alignerProcess",
        icon: "ico_aligner_process",
        enable: true
      },
      {
        label: "账单明细",
        value: "billingDetails",
        icon: "ico_billing_detail",
        enable: true
      },
      {
        label: "病例进度",
        value: "caseProgress",
        icon: "ico_case_progress",
        enable: true
      },
      {
        label: "CT文件下载",
        value: "ctFilesDownload",
        icon: "ico_ct_files_download",
        enable: true
      }
    ],
    caseId: "病例编号：",
    clinic: "治疗诊所：",
    treatment: "矫治方式：",
    birth: "出生日期：",
    birth2: "出生日期",
    diagnosisInfo: "诊断信息：",
    tpListTabTitle: "3D方案设计",
    more: "更多",
    tpListEmpty: "尚未创建3D设计方案",
    alignerProcessingStatus: "矫治器加工情况",
    recentProduce: "最近生产",
    quickNavTitle: "快速查询",
    caseStageTitle: "病例进度",
    stageListMore: "查看全部病例进度",
    designDetailTitle: "设计详单",
    downloadWithPDF: "下载PDF",
    tpIntroHtmlTitle: "治疗概况报告",
    orthodonticProcessListTab: "最近生产记录",
    picExplorer: "图像浏览器",
    imageDoc: "影像资料",
    xRayFile: "X光片",
    otherFile: "其他资料",
    submitProduce: "提交生产",
    btnSubmitProduce: "提交生产",
    produceAligner: "再生产10套矫治器",
    alignerSendIntro: "矫治器默认发货10套/次",
    alignerReceiveAddr: "矫治器收获地址：",
    submitIntro: "*提交后无法更改，如需特殊说明或修改地址请联系客服。",
    cancelContent: "取消",
    wearRecord: "牙套佩戴记录",
    wearStartDateLab: "设置牙套佩戴起始日期",
    wearStartStepLab: "设置当前佩戴起始步数",
    wearStartStepLab1: "设置当前佩戴起始步数(上颌)",
    wearStartStepLab2: "设置当前佩戴起始步数(下颌)",
    wearDurationLab: "单个牙套佩戴时效（天）",
    submitContent: "确定",
    processPlanTab: "现在想？",
    btnProduceContent: "再生产10套",
    stageAdjustLab: "进行阶段调整",
    produceHeaderLab: "生产",
    wearStepLab: "佩戴步数:",
    wearDaysLab: ["可佩戴", "天"],
    producedLab: "已生产",
    totalStepsLab: "总步数",
    imageInfosLab: [
      "正面像",
      "正面微笑", //1
      "右侧面像", //2
      "正面咬合像", //3
      "上牙列像", //4
      "下牙列像", //5
      "口内左侧位像", //6
      "口内右侧位像", //7
      "X光片", //8
      "头颅侧位定位片", //9
      "全颌曲面断层片", //10
      "其它照片" //11
    ],
    addWearDate: "添加佩戴日期",
    btnAddWearInfo: "点击添加",
    errorMsg: "用户无此权限",
    tpApprove: ["未审核", "未通过", "已审核"],
    downloadFile: "下载文件",
    downloadDesignDetailTitle: "无托槽隐形矫治器设计单",
    downloadTpIntroTitle: "无托槽隐形矫治器方案说明书",
    schemeReportInfoTitle: "治疗概况报告",
    orthodonticProcessItem: [
      "生产提交",
      "生产中",
      "已发货",
      "已收货",
      "已佩戴"
    ],
    processStageContent: ["共", "步"],
    wearRecordPlaceholder: ["选择日期", "第几步", "天数"],
    wearRecordSubmitAlert: [
      "数字不能为负数",
      "设置当前佩戴起始步数应该介于",
      "和",
      "之间",
      "关键字不能为空",
      "佩戴天数不能小于"
    ],
    correctionType: ["未选择治疗计划", "隐形矫治", "舌侧矫治"],
    stageAdjust: "阶段调整",
    alignerProduce: "加工生产",
    designDetail: {
      orderNumber: "订单编号：",
      company: "医院/诊所",
      doctor: "医生姓名",
      address: "收件地址",
      telephone: "联系方式",
      patientName: "患者姓名",
      patientsDemand: "患者主诉",
      customer: "客户",
      date: ["年", "月", "日"],
      receiver: "接单人",
      orderDate: "接单日期",
      checker: "审核人",
      checkDate: "审核日期",
      gender: "性别",
      birthday: "年龄",
      plan: "医生治疗方案",
      orthodonticTreatment: "矫治方式",
      planContent: "诊断信息",
      senderAddress: "寄件地址",
      consignee: "收 件 人:"
    }
  },
  alignerProcess: {
    diaphragmSpecificationOpts: [
      {
        label: "标准版",
        value: 1
      },
      {
        label: "升级版",
        value: 2
      },
      {
        label: "豪华版",
        value: 3
      }
    ],
    coverWisdomTeethOpts: [
      {
        label: "是",
        value: 1
      },
      {
        label: "否",
        value: 2
      }
    ],
    edgeFormOpts: [
      {
        label: "波浪式",
        value: 1
      },
      {
        label: "平直式",
        value: 2
      }
    ],
    edgeHeightOpts: [
      {
        label: "龈上",
        value: 1
      },
      {
        label: "龈下0-1mm",
        value: 2
      }
    ]
  },
  // 创建病历
  createCase: {
    length: "长度",
    nameInputError: "姓名只能包含中文、英文字母和数字",
    nameLengthError: "姓名长度不能超过30个字符",
    quicklyCreate: "快速创建",
    zizhu: "自主",
    DIY: "自主",
    basicInfo: "基本信息",
    name: "姓名",
    sex: "性别",
    mainDoctor: "主治医生",
    hospitalName: "医院/诊所",
    addressTip: "请先选择地址，诊所选择地址后自动填充",
    mailingAddress: "邮寄地址",
    mailingAddressInfo: [
      "收件人姓名",
      "收件人手机号码",
      "医院/诊所",
      "邮政编号",
      "收件地址",
      "默认地址"
    ],
    uploadDigitalModel: "上传数字模型",
    tipA: "若您无法上传数字模型可以通过快递的方式发送给我们。",
    clickHere: "点击此处",
    gender: ["男", "女"],
    tipB: "切换快递方式。",
    addNewAddress: "添加新地址",
    upload: ["点击上传", "文件名称", "上传进度", "操作", "删除"],
    mailingModel: "邮寄模型",
    tipC: "若您可以通过上传数字模型，",
    tipD: "切换“上传数字模型”方式。",
    createCaseBtn: ["取消", "创建病例", "阶段调整", "修改病例"],

    doctorEmpty: "医生姓名为空，请选择治疗医生",
    createCaseSuccess: "创建病例成功",
    updateCaseSuccess: "修改病例成功",
    restartCaseSuccess: "病例阶段调整成功"
  },
  detailvue_Case_info: {
    crowdding: "拥挤",
    sparse: "稀疏",
    overbite: "深覆合",
    overjet: "深覆盖",
    class_II_I: "II类一分类",
    class_II_II: "II类二分类",
    class_III: "III类",
    edge_to_edge_bite: "对刃",
    open_bite: "开合",
    anterior_crossbite: "前牙反合",
    posterior_crossbite: "后牙反合",
    narrow_dental_arch: "牙弓狭窄",
    gingival_inflammationl: "牙周红肿",
    oral_inflammation: "口腔炎症",
    osteoporosis: "骨质疏松",
    TMJ_disorders: "颞颌关节紊乱",
    protrusion: "前突",
    inadequate_smile_line: "笑线不调",
    deformed_teeth: "畸形牙",
    other: "other",
    molar_distalization: "磨牙远移",
    molar_mesialization: "磨牙近移",
    IPR: "临面去釉",
    anterior_intrusion: "压低前牙",
    posterior_intrusion: "压低后牙",
    anterior_extrusion: "伸长前牙",
    posterior_extrusion: "升高后牙",
    anterior_teeth_proclination: "前牙唇倾",
    bite_guard: "颌垫",
    arch_constriction: "缩弓",
    posterior_lingual_inclination: "后牙舌倾",
    posterior_buccal_inclination: "后牙颊倾",
    derotation: "解除扭转",
    class_III_elastics: "III类牵引",
    extraction_of_third_molars: "拔智齿"
  },

  //设计中心
  yulanDesignCenter: "悠蓝设计服务中心",
  otherDesignCenter: "其他设计中心",

  三维展示区: "三维展示区",
  登录: "登录",
  AI重塑正畸生态: "AI重塑正畸生态",
  让医疗回归本质: "让医疗回归本质",
  与正畸医生同行: "正畸医生同行",
  使用微信扫一扫: "使用微信扫一扫",
  申请软件试用: "申请软件试用",
  找回密码: "找回密码",
  成为医生: "成为uAlign AI医生",
  返回登录页面: "返回登录页面",
  重置密码: "重置密码",
  请填写您需要找回的账号: "请填写您需要找回的账号",
  短信验证: "短信验证",
  验证码已经发送至: "验证码已经发送至",
  验证码错误: "验证码错误",
  请重新输入: "请重新输入",
  新密码: "新密码",
  设置您的新密码并再次确认: "设置您的新密码并再次确认",
  两次密码不一致: "两次密码不一致",
  成功: "成功",
  已为您的账号完成密码重置: "已为您的账号完成密码重置",
  立即登录: "立即登录",
  我们使用和其他跟院技术: "我们使用 Cookies和其他跟院技术",
  用于改善网页监体验提供性化内容和广告:
    "用于改善网页监体验、提供性化内容和广告",
  和优化网页功能: "和优化网页功能",
  阅读将私条款和用户使用协议以下统称条款:
    "阅读将私条款和用户使用协议以下统称“条款”",
  同意: "同意",
  了解更多: "了解更多",
  表示您同意: "继续即表示您同意我们使用前述所述的技术和条款约定",
  备案号: "备案号",
  矫治器制作单2: "矫治器制作单",
  矫治器制作单: "矫治器制作单",
  牙套佩戴记录: "牙套佩戴记录",
  生产记录: "生产记录",
  文件名称: "文件名称",
  上传时间: "上传时间",
  操作: "操作",
  下载: "下载",
  删除: "删除",
  修改: "修改",
  查看全部: "查看全部",
  方案管理: "方案管理",
  暂无数字模型方案: "暂无数字模型方案",
  矫治情况: "矫治情况",
  最近矫治器生产情况: "最近矫治器生产情况",
  步前: "步前",
  添加佩戴日期: "添加佩戴日期",
  其他临床操作说明: "其他临床操作说明",
  粘贴附件分步图: "粘贴附件分步图",
  邻面去釉分步图: "邻面去釉分步图",
  工作台: "工作台",
  患者详情: "患者详情",
  患者姓名: "患者姓名",
  将病例: "将病例交由该设计者进行方案设计处理 (技工、医生 二选一)",
  技工列表: "技工列表",
  医生列表: "医生列表",
  专家列表: "专家列表",
  将病例交由该专家: "将病例交由该专家进行方案审核处理",
  取消: "取消",
  提交: "提交",
  智上悠蓝: "智上悠蓝",
  绘制未来: "绘制未来",
  立即参与: "立即参与",
  悠蓝智绘: "悠蓝智绘",
  个人中心: "个人中心",
  退出登陆: "退出登陆",
  病例类型: "病例类型",
  选择委托设计方: "选择委托设计方",
  收件地址: "收件地址",
  添加新地址: "添加新地址",
  顺时针: "顺时针",
  逆时针: "逆时针",
  水平翻转: "水平翻转",
  垂直翻转: "垂直翻转",
  生产详细: "生产详细",
  生产步数: "生产步数",
  上颌: "上颌",
  数量: "数量",
  下颌: "下颌",
  附件模板: "附件模板",
  被动矫治器: "被动矫治器",
  数据合计: "数据合计",
  仅输出数据: "仅输出数据",
  发送邮箱: "发送邮箱",
  膜片规格: "产品系列",
  期望生产完成日期: "期望生产完成日期",
  生产批号: "生产批号",
  加工要求: "加工要求",
  矫治器是否覆盖智齿: "矫治器是否覆盖智齿",
  矫治器边缘形态: "矫治器边缘形态",
  矫治器位于牙龈缘高度: "矫治器位于牙龈缘高度",
  门诊: "医院/诊所",
  医生: "医生",
  下单时间: "下单时间",
  总步数: "总步数",
  总数: "总数",
  矫治器: "矫治器",
  附件模版: "附件模版",
  完成时间: "完成时间",
  收件人: "收件人",
  联系方式: "联系方式",
  提交后无法更改如需特殊说明:
    "提交后无法更改，如需特殊说明或修改地址请联系客服。",
  提交病例: "提交病例",
  可佩戴: "可佩戴",
  天: "天",
  新建病例: "新建病例",
  来源: "来源",
  性别: "性别",
  临床诊断信息: "临床诊断信息",
  矫正方法: "矫正方法",
  方案说明: "方案说明",
  专家审核: "专家审核",
  专家审核中: "专家审核中",
  医生审核: "医生审核",
  医生审核中: "医生审核中",
  添加邮寄地址: "添加邮寄地址",
  用户名: "用户名",
  修改用户名: "修改用户名",
  修改密码: "修改密码",
  登录密码: "登录密码",
  手机: "手机",
  修改手机: "修改手机",
  邮箱: "邮箱",
  修改邮箱: "修改邮箱",
  退出登录: "退出登录",
  帐号状态: "帐号状态",
  编辑: "编辑",
  管理寄送地址: "管理寄送地址",
  保存: "保存",
  邮寄地址: "邮寄地址",
  轻松创建分享链接: "轻松创建分享链接",
  一键分享动画方案: "一键分享动画方案",
  新方案: "新功能【3D方案分享】",
  让远程方案演示: "让远程方案演示和沟通更便捷",
  了解详细: "了解详细",
  设计中心病例: "设计中心病例",
  累计: "累计",
  例: "例",
  我的账单: "我的账单",
  查看更多: "查看更多",
  我的U币: "我的U币",
  累计收益: "累计收益",
  累计支出: "累计支出",
  牙套生产: "牙套生产",
  设计订单: "设计订单",
  相关应用工具: "相关应用工具",
  桌面端下载: "桌面端下载",
  病例管理小程序: "病例管理小程序",
  手机客户端: "手机客户端支持上传、查看、审核病例。",
  微信小程序: "扫码进入微信小程序",
  分析: "分析",
  全设计方案:
    "全设计方案20073117牙冠较短移动效果不确切请临床矫治中关注移动情况关注智齿的萌出情况若影响移动请临床择期拔除矫治过程中请临床注意检查邻接是否过紧",
  必要时需砂条松解: "必要时需砂条松解",
  尤其是扭转牙: "尤其是扭转牙的近远中中请临床注意检查邻接是否过紧",
  尤其是扭转牙的近远中: "尤其是扭转牙的近远中",
  模拟方案: "模拟方案",
  实际治疗效果可能不同: "实际治疗效果可能不同",
  查看方案: "查看方案",
  上海悠蓝智绘技术有限公司版权所有: "上海悠蓝智绘技术有限公司 版权所有",
  留言: "留言",
  订单号: "订单号",
  备注视频输出到: "备注：视频（GIF）输出至浏览器默认下载文件夹。",
  视角: "视角",
  显示: "显示",
  步骤: "步骤",
  速度: "速度",
  当前: "当前",
  动画生成中: "动画生成中",
  合成中: "合成中",
  复制: "复制",
  公开分享方案: "公开分享方案（已开启）",
  开启分享后获得链接: "开启分享后，获得链接和密码的人可以在有效期内查看方案",

  开启分享即视为已知晓并同意接受:
    "开启分享，即视为已知晓并同意接受风险提醒内容，如关闭分享，之前生成的所有分享链接均会立即失效。",

  有效时间: "有效时间",
  机构: "设计中心",
  创建成功: "创建成功",
  通过UAlign悠蓝智绘: "通过悠蓝智绘 分享的",
  隐形矫治3D设计方案: "隐形矫治3D设计方案",
  链接: "链接",
  密码: "密码",
  点击链接并输入密码查看方案:
    "点击链接并输入密码查看方案。该方案为模拟方案，实际效果可能不同。链接包含个人信息，请勿转发给他人。",
  关于我们: "关于我们",
  悠蓝学院: "悠蓝学院",
  病例编号: "病例编号",
  设计者列表: "设计者列表",
  提交生产: "提交生产",
  确认生产: "确认生产",
  物流跟踪: "物流跟踪",
  起始步数: "起始步数",
  结束步数: "结束步数",
  生产数量: "生产数量",
  请输入发送邮箱: "请输入发送邮箱",
  选择日期: "选择日期",
  生产批号填写: "生产批号填写",
  此处添加备注信息: "此处添加备注信息(不超过260个字符)",
  确定: "确定",
  再次输入: "再次输入",
  审核: "审核",
  请输入: "请输入",
  原密码: "原密码",
  重复一次新密码: "重复一次新密码",
  修改手机号码: "修改手机号码",
  请输入新的手机号码: "请输入新的手机号码",
  请输入您的登陆密码: "请输入您的登陆密码",
  请输入新邮箱地址: "请输入新邮箱地址",
  请输入密码: "请输入密码",
  请输入备注信息: "请输入备注信息",
  您没有权限进行此操作: "您没有权限进行此操作",
  步: "步",
  下载CT文件失败: "下载CT文件失败",
  设计详单: "设计详单",
  自主设计病例: "自主设计病例",
  临时病例: "临时病例",
  年: "年",
  月: "月",
  日: "日",
  照片浏览器: "照片浏览器",
  正面像: "正面像",
  正面微笑: "正面微笑",
  右侧面像: "右侧面像",
  正面咬合像: "正面咬合像",
  口内左侧位像: "口内左侧位像",
  口内右侧位像: "口内右侧位像",
  上牙列像: "上牙列像",
  下牙列像: "下牙列像",
  全颌曲面断层片: "全颌曲面断层片",
  头颅侧位定位片: "头颅侧位定位片",
  其他照片1: "其他照片-1",
  其他照片2: "其他照片-2",
  其他照片3: "其他照片-3",
  治疗概况报告: "治疗概况报告",
  请选择设计者: "请选择设计者",
  请选择专家: "请选择专家",
  医生diy方案数据审核失败: "医生diy方案数据审核失败",
  全部: "全部",
  工作站: "工作站",
  // 中文: "中文",
  确定要退出登陆: "确定要退出登陆?",
  qt对象未获取到: "qt对象未获取到！",
  获取设计中心信息失败: "获取设计中心信息失败",
  发送邮箱不能为空: "发送邮箱不能为空",
  快递信息不能为空: "快递信息不能为空",
  成功提交生产: "成功提交生产",
  生产起始步数不能比已完成步数小: "生产起始步数不能比已完成步数小",
  生产结束步数不能比已开始步数小: "结束步数应大于起始步数",
  备注字符长度不能超过260: "备注字符长度不能超过260",
  请输入正确的数字: "请输入正确的数字",
  当前视图: "当前视图",
  正面: "正面",
  左视图: "左视图",
  右视图: "右视图",
  俯视: "俯视",
  多角度: "多角度",
  手机号码: "手机号码",
  用户名必填: "用户名必填",
  手机号码必填: "手机号码必填",
  手机号码格式错误: "手机号码格式错误",
  新密码必填: "新密码必填",
  确认密码必填: "确认密码必填",
  密码长度: "密码长度在6-32位",
  新密码两次输入不一致: "新密码两次输入不一致",
  其他字符: "其他字符",
  患者: "患者",
  病历号: "病历号",
  主诉: "主诉",
  就诊时间: "就诊时间",
  门诊单位: "门诊单位",
  提交时间: "提交时间",
  状态: "状态",
  设计中心: "设计中心",
  生产编号字符长度不能超过20: "生产编号字符长度不能超过20",
  病例分配: "病例分配",
  提交病例失败: "提交病例失败",
  厂家方案审核失败: "厂家方案审核失败",
  确认收货成功: "确认收货成功",
  操作成功: "操作成功",
  病例领取: "病例领取",
  医生治疗方案字数不能超过300: "医生治疗方案字数不能超过300",
  我的病例: "我的病例",
  患者列表: "患者列表",
  患者主诉: "患者主诉",
  男性: "男性",
  男: "男",
  女性: "女性",
  女: "女",
  提交方案: "提交方案",
  方案专家审核: "方案专家审核",
  方案医生审核: "方案医生审核",
  专家审核未通过: "专家审核未通过",
  专家审核通过: "专家审核通过",
  方案医生审核未通过: "方案医生审核未通过",
  方案医生审核通过: "方案医生审核通过",
  发货地址不能为空: "发货地址不能为空，请选择发货地址",
  膜片规格必填: "膜片规格必填",
  期望生产完成日期必填: "期望生产完成日期必填",
  牙套生产信息错误: "牙套生产信息错误",
  发送邮箱必填: "发送邮箱必填",
  请输入正确的邮箱地址: "请输入正确的邮箱地址",
  数据错误: "数据错误",
  修改成功: "修改成功",
  姓名不能为空: "姓名不能为空",
  请输入中文字或字母: "请输入中文字或字母",
  姓名长度超过40限制: "姓名长度超过40限制",
  参数错误: "参数错误",
  原密码不能为空: "原密码不能为空",
  新密码不能为空: "新密码不能为空",
  新的手机号码不能为空: "新的手机号码不能为空",
  请输入正确的手机号码: "请输入正确的手机号码",
  邮箱不能为空: "邮箱不能为空",
  待收货: "待收货",
  已收货: "已收货",
  生产提醒: "生产提醒",
  李菊英: "李菊英",
  吴彦翰: "吴彦翰",
  李思霖: "李思霖",
  你所输入的患者主诉不能超过300字: "你所输入的患者主诉不能超过300字",
  患者主诉字数不能超过300: "患者主诉字数不能超过300",
  保存本地草稿成功: "保存本地草稿成功，下次创建病例可以选择加载",
  红色号标记的重要信息不能为空: "红色*号标记的重要信息不能为空",
  牙位: "牙位",
  附件: "附件",
  邻面去釉: "邻面去釉",
  网格: "网格",
  叠加: "叠加",
  咬合接触: "咬合接触",
  仅上颌: "仅上颌",
  右侧: "右侧",
  仰视: "仰视",
  左侧: "左侧",
  后视: "后视",
  仅下颌: "仅下颌",
  没有上颌方案: "没有上颌方案",
  没有下颌方案: "没有下颌方案",
  数据加载失败: "数据加载失败",
  初始数据加载失败: "初始数据加载失败",
  牙齿文件加载错误: "牙齿文件加载错误",
  第: "第",
  步去釉: "步去釉",
  你输入的密码不正确: "你输入的密码不正确，不能预览方案，请输入正确的密码",
  专家: "专家",
  通过: "通过",
  不通过: "驳回",
  请选择审核结果: "请选择审核结果",
  评审失败: "评审失败",
  慢速: "慢速",
  中速: "中速",
  快速: "快速",
  导出步骤格式错误: "导出步骤格式错误",
  结束步骤不能比开始步骤小: "结束步骤不能比开始步骤小",
  技工提交方案: "提交方案",
  更多记录: "更多记录",
  折叠: "折叠",
  复制成功: "复制成功",
  天1: "1天",
  天3: "3天",
  天7: "7天",
  不显示: "隐藏",
  最大步数超过方案步数最大值: "参数错误--最大步数超过方案步数最大值",
  病例资料: "病例资料",
  分步信息: "分步信息",
  历史方案: "历史方案",
  矫治说明: "矫治说明",
  分享: "分享",
  导出: "导出",
  方案初始化错误: "方案初始化错误",
  牙齿初始化错误: "牙齿初始化错误",
  牙龈初始化错误: "牙龈初始化错误",
  萌出帽初始化错误: "萌出帽初始化错误",
  init数据加载失败: "init数据加载失败",
  文件加载错误: "文件加载错误",
  评审检测错误: "评审检测错误",
  设计阶段: "设计阶段",
  阶段调整: "阶段调整",
  姓名病例号医院: "姓名 病例号 医院",
  病例号: "病例号",
  确认发货: "确认发货",
  个: "个",
  驳回备注: "驳回备注",
  确认接收改病例: "确认接收改病例",
  接收病例: "接收病例",
  自定义: "自定义",
  备注: "备注",
  牵引钩在: "牵引钩，在",
  放置牵引钩: "（牙位）上，放置牵引钩，如需我们生产，此操作不需要您临床操作",
  开窗在: "开窗,在",
  放置开窗: "（牙位）上，放置开窗，如需我们生产，此操作不需要您临床操作",
  压力嵴在: "压力嵴,在",
  放置压力嵴: "（牙位）上，放置压力嵴，如需我们生产，此操作不需要您临床操作"
   
};



// WEBPACK FOOTER //
// ./src/i18n/lang/zh.js